import { makeStyles } from "@material-ui/core";


export default makeStyles(theme => ({
    actions: {
        marginTop: 24,
        fontSize: 16,
        display: "flex",
        justifyContent: "end",
        alignItems: "center",
        "& button": {
            fontWeight: "bold",
            marginLeft: 16,
        },
    },
    body: {
        margin: 40,
        borderRadius: 12,
    },
    checkbox: {
        margin: "8px 0px",
        height: 24,
        "& .MuiIconButton-root": {
            paddingLeft: 0,
        },
    },
    checkboxColumns: {
        width: "50%",
    },
    close: {
        marginRight: -12,
    },
    detailIcon: {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[700],
    },
    details: {
        display: "flex",
        alignItems: "center",
        margin: "12px 0px",
    },
    detailItem: {
        width: "33%",
    },
    dialog: {
        minWidth: 740,
        maxWidth: "none",
        width: 800,
    },
    divider: {
        margin: "8px 0px",
    },
    form: {
        display: "flex",
        alignItems: "center",
        margin: "16px 0px",
    },
    head: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: 32,
    },
    note: {
        width: "50%",
        marginLeft: 16,
        overflowY: "scroll",
    },
}));
